import { makeStyles } from '@material-ui/styles';
import { Theme, Text } from '@bizzabo/design-system';
import { Event } from '@bizzabo/entities';

export interface BanUserInformationMessageProps {
    event: Event;
}
const BanUserInformationMessage: React.FC<BanUserInformationMessageProps> = ({ event }) => {
    const classes = useStyles();
    const orgEmail = event.supportEmail;
    const mailTo = 'mailTo:' + orgEmail;
    return (
        <div className={classes.container}>
            <Text variant="t81" className={classes.text}>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                You've been blocked from all communication during this event. For more information:{' '}
                <a className={classes.mailTo} href={mailTo}>
                    {orgEmail}
                </a>
            </Text>
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            padding: '10px 10px 10px 26px',
            background: theme.palette.greys['200'],
        },
        text: {
            color: theme.palette.greys['700'],
        },
        mailTo: {
            color: 'rgb(47, 134, 215)',
        },
    }),
    {
        classNamePrefix: 'BanUserInformationMessage',
    }
);

export default BanUserInformationMessage;
